var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        {
          class: [
            "parametric",
            {
              "is-ready": _vm.isReady,
              "is-overlay": _vm.isFilterOpen
            }
          ]
        },
        [
          _c(
            "div",
            { staticClass: "parametric__head" },
            [
              _c("div", { staticClass: "parametric__title" }, [
                _c("h3", { staticClass: "parametric-title__title" }, [
                  _vm._v(
                    "\n                    " +
                      _vm._s(
                        _vm.isEstateFlat ? "Апартаменты" : "Коммерческая"
                      ) +
                      "\n                "
                  )
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "parametric-title__label" }, [
                  _vm._v(_vm._s(_vm.flats.length) + " в продаже")
                ])
              ]),
              _vm._v(" "),
              _vm.isMobile ? _c("OpenFilter") : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c("Filters", {
            ref: "filter",
            attrs: { isFilterOpen: _vm.isFilterOpen },
            on: {
              close: function($event) {
                _vm.isFilterOpen = false
              },
              openModal: _vm.openGenplan
            }
          }),
          _vm._v(" "),
          _c("Results")
        ],
        1
      ),
      _vm._v(" "),
      _c("GenplanPopup", {
        ref: "genplanModal",
        on: { sendBuilding: _vm.buildingSelect }
      }),
      _vm._v(" "),
      _c("DetailPopup", {
        ref: "detailPopup",
        on: { closed: _vm.detailPopupClosed }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }